import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Orders from "./components/Orders";
import ProductId from "./components/ProductId";
import Login from "./components/Login";
import SingUp from "./components/SingUp";
import Profile from "./components/Profile";
import Product from "./components/Product";
import Address from "./components/Address";
import Checkout from "./components/Checkout";
import OrderId from "./components/OrderId";
import Cart from "./components/Cart";
import Setting from "./components/Setting1/Setting";
import ChangePassword from "./components/Setting1/ChangePassword";
import ChangeProfile from "./components/Setting1/ChangeProfile";
import UploadAvatar from "./components/Setting1/UploadAvatar";
import "./css/main.css";
import NotFound from "./components/NotFound";
import { useEffect, useState } from "react";
import { getProfile } from "./redux/action";
import { useDispatch, useSelector } from "react-redux";

function App() {
  const dispatch = useDispatch();
  const { data, error } = useSelector((state) => state.Profile);
  /////////////////////////////////////////////////////////////////
  const [login, setlogin] = useState(false);
  const storageUser = JSON.parse(localStorage.getItem("User")) ?? false;

  useEffect(() => {
    storageUser && setlogin(true);
  }, [storageUser]);
  const [QTY, setQTY] = useState(0);
  ///////////////////////////////////////////////////////////////   Load
  useEffect(() => {
    if (storageUser && login) {
      dispatch(getProfile());
    }
  }, []);

  if (login && error) {
    setlogin(false);
    localStorage.removeItem("User");
  }
  /////////////////////////////////////////////////////////////

  return (
    <div className="App">
      <Navbar login={login} setlogin={setlogin} />
      <Routes>
        <Route
          path="/"
          element={<Product login={login} setlogin={setlogin} />}
        />
        <Route path="/ProductId" element={<ProductId setQTY={setQTY} />} />
        <Route path="/Orders" element={login ? <Orders /> : <NotFound />} />
        <Route
          path="/Login"
          element={!login ? <Login setlogin={setlogin} /> : <NotFound />}
        />
        <Route path="/SingUp" element={!login ? <SingUp /> : <NotFound />} />
        <Route path="/Profile" element={login ? <Profile /> : <NotFound />} />
        <Route path="/Address" element={login ? <Address /> : <NotFound />} />
        <Route
          path="/Checkout"
          element={login ? <Checkout setQTY={setQTY} /> : <NotFound />}
        />
        <Route path="/Cart" element={<Cart setQTY={setQTY} login={login} />} />
        <Route path="/OrderId" element={login ? <OrderId /> : <NotFound />} />
        <Route path="/Setting" element={login ? <Setting /> : <NotFound />}>
          <Route
            path="ChangeProfile"
            element={login ? <ChangeProfile /> : <NotFound />}
          />
          <Route
            path="ChangePassword"
            element={login ? <ChangePassword /> : <NotFound />}
          />
          <Route
            path="UploadAvatar"
            element={login ? <UploadAvatar /> : <NotFound />}
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
